import styled from 'styled-components';
import { SIZE } from '@app/src/ui';
import { getImageByAlias, getColorRgbByAlias } from '@app/src/utils/categories';

interface Props {
  alias: string;
  heightHeader: number;
}

export const WrapperStep = styled.div`
  width: 100%;
  display: flex;
  position: relative;
`;

export const WrapperStepLeft = styled.div`
  background-image: ${(props: Props) => props.alias && `url(${getImageByAlias(props.alias)})`};
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  display: none;
  height: 100%;
  width: 30%;
  ${(props: Props) => props.heightHeader && `
    top: ${props.heightHeader}px;
  `}
  position: fixed;

  @media (min-width: ${SIZE.LARGE_DESKTOP}) {
    display: block;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props: Props) => `rgba(${getColorRgbByAlias(props.alias)}, .5)`};
  width: 100%;
  height: 100%;
`;

export const WrapperStepRight = styled.div`
  padding: 40px 0 0;
  background: #fff;
  width: 100%;
  position: relative;
  ${(props: Props) => props.heightHeader && `
    min-height: calc(100vh - ${props.heightHeader}px);
  `}
`;

export const Container = styled.div`
  flex-direction: column;
  height: 100%;
  display: flex;
  justify-content: space-between;
  max-width: 490px;
  margin: 0 auto;
`;

export const Wrapper = styled.div`
  height: 100%;
`;